module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp3",
    attrs: {
      "id": "cast"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "x01-fm-head"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Cast")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-body-text-fl-"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Principal characters in order of appearance")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Phil Jones: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("concert promoter, Alexandra Palace and Spike Island")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Gareth Evans: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("manager of The Stone Roses and owner of the International and International")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("II")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("clubs")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Ian Brown (nickname IBEX): "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("singer, The Stone Roses")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Matthew Cummins (RIP): "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Evans’s business partner, co-manager of The Stone Roses and co-owner of the International clubs")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Paul Oakenfold: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("DJ")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("at Alexandra Palace and Spike Island")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Dave Haslam: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("author;")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("DJ")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("at Blackpool Empress Ballroom, Alexandra Palace and Spike Island")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Dave Booth: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("DJ")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("at Blackpool Empress Ballroom and Spike Island")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Reni (Alan Wren): "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("drummer, The Stone Roses")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Adrian Sherwood: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("producer; remixed ‘One Love’ and support act at Spike Island")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Philip Hall (RIP): "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("press officer, The Stone Roses, and the band’s manager in")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("1993")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("John Squire (often Johnny): "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("guitarist, The Stone Roses")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Stephen ‘Cressa’ Cresser: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Stone Roses’ road crew and on-stage vibes")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Mani (Gary Mounfield): "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("bassist, The Stone Roses")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Peter Hook: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Joy Division and New Order; producer of ‘Elephant Stone’")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Steve Lock: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Granada")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("TV")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("producer, filmed Alexandra Palace")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Roddy McKenna: A"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("&R at Jive/Zomba")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Kevin Cummins: NME "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("photographer")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Si Wolstencroft: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("original drummer in The Stone Roses,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("1983")]), _vm._v("–4")]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Pete Garner: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("original bass player in The Stones Roses,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("1983")]), _vm._v("–"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Andy Couzens: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("original guitarist in The Stones Roses,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("1983")]), _vm._v("–6")]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Pennie Smith: NME "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("photographer, The Stone Roses’ photographer")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Mensi (Thomas Mensforth): "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("lead singer, Angelic Upstarts")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Mike Phoenix: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("scooterboy and founder of the Twisted Wheel")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("SC")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("club")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Johnny Poland: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("scooterboy and style influence")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Johnny Bolland: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("scooterboy and manufacturer of the Stone Roses T-shirts")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Kaiser (David Carty): "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("scooterboy and singer, The Waterfront")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Chris Goodwin: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("drummer, The Waterfront")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Michelle ‘Mitch’ Davitt: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Ian Brown’s partner")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Sue Dean: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("photographer and girlfriend of Gareth Evans")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Rob Hampson: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("scooterboy and bassist in The Stone Roses,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("1987")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Geno Washington: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("soul sensation and life coach")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("John Breakell: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("owner of Spirit Studios")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Caroline Reed: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("first manager of The Stone Roses,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("1984")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Tony Wilson (RIP): "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("co-founder of Factory Records")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Garry Johnson: Sounds "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("writer and band champion")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Howard Jones: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("manager of The Stones Roses,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("1984–6")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Tim Chambers: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("co-founder of Thin Line Records")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Martin Hannett (RIP): "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("producer; co-founder of Thin Line Records")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Steve ‘Adge’ Atherton: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Stone Roses’ tour manager")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Tony Michaelides: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("DJ")]), _vm._v(", "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Piccadilly Radio, Manchester")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Paula Greenwood: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Piccadilly Radio/Piccadilly Records and")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("PR")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("at the International clubs")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Bob Dickinson: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("journalist, Manchester")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Andreas Kemi: The Eye "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("magazine, Swedish tour promoter")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Toxin Toy (Harald Sickenga, Micke Mürhoff, Anette Svensson and Christian Adelöv): "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("co-headliners of Swedish tour")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Glen Greenough (RIP): "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Stone Roses’ first roadie")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Lena Kagg: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("photographer on Swedish tour")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Clive Jackson: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("singer with Doctor & The Medics")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Slim (Paul Haley): "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Stone Roses’ road crew")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Martin Pendergast (‘Little Martin’): "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Haçienda")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("DJ")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and ‘Baldrick’")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Al Smith: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("‘Baldrick’ and The Stone Roses’ road crew")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Phil Saxe: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("source of flared jeans,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("1983")]), _vm._v("–4, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("and manager of the Happy Mondays")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Chris Nagle: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("engineer for Martin Hannett")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Dennis Morris: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("photographer, artist, stylist and club runner")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Helen Plaumer: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("John Squire’s partner")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Dougie James: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("soul singer, club runner and original owner of the International")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Roger Eagle (RIP): "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("booker at the International")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Stephen Lea: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("lawyer, acting for Andy Couzens and The Stone Roses")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Dave Roberts: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A&R at")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("FM")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Revolver/Heavy Metal Records")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Paul Birch: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("owner of")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("FM")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Revolver/Heavy Metal Records")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Simon Machan (‘Big Simon’): "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Stone Roses’ road crew, live sound")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Lindsay Reade: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("co-manager of The Stone Roses,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("1987")]), _vm._v("–8")]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Geoff Travis: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("founder of Rough Trade Records")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Ian Tilton: Sounds "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("photographer, The Stone Roses’ photographer")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Steven Howard: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("managing director of Jive Records and Zomba Music Publishing")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Clive Calder: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("founder of Jive/Zomba")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Geoff Howard: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Gareth Evans’s lawyer and The Stone Roses’ legal representative")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("John Leckie: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("producer of")]), _vm._v(" The Stone Roses"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v(", ‘Fools Gold’, ‘One Love’ and")]), _vm._v(" Second Coming")]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Andrew Lauder: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("manager of Silvertone Records")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Lawrence Stewart: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("engineer at Coconut Grove Studios")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Paul Schroeder: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("producer and engineer on")]), _vm._v(" The Stone Roses"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v(", ‘Fools Gold’, ‘One Love’ and")]), _vm._v(" Second Coming")]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Chris Donnelly: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("co-founder of Gio-Goi")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Anthony Donnelly: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("co-founder of Gio-Goi")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Gareth Davies: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Stone Roses’ radio and TV plugger")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Phil Smith: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Stone Roses’ road crew")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Chris ‘The Piss’ Griffiths: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Stone Roses’ road crew")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Greg Lewerke: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Gareth Evans’s American manager and de facto The Stone Roses’ American manager")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Nigel Kerr: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("booking agent, The Stone Roses")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Jon Brookes: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("drummer, The Charlatans")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Tim Vigon: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("creator of")]), _vm._v(" Made of Paper"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v(", the Stone Roses fanzine")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("‘The Bobs’: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Eileen Mulligan, Shirley McGurrin and sisters Colette and Theresa Shryane")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Bruce Mitchell: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("founder of Manchester Light & Stage Company")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Geoff Wonfor: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("film-maker, videos for Blackpool, ‘Fools Gold’ and ‘I Wanna Be Adored’")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Keith Jobling: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Bailey Brothers, Factory-affiliated film-makers")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Joe Bloggs: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Bushra Ahmed and Shami Ahmed, Manchester fashion company")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Anthony Boggiano: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("manager of Inspiral Carpets")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Barry Weiss: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("manager of New York offices of Zomba")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Michael Tedesco: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Stone Roses’ American A&R at Zomba")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Bruce Flohr: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("radio plugger at")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("RCA")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Robbie Snow: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("product manager at")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("RCA")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Mark Furman: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Jive/Zomba business affairs")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("John Fruin (RIP): "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Jive/Zomba senior management")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("John Kennedy: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Stone Roses’ lawyer")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("David Geffen: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("owner of Geffen Records")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Eddie Rosenblatt: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("president of Geffen Records")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Gary Gersh: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A&R at Geffen Records")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Steve Jenkins: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("general manager of Jive Records")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Maurice Oberstein (RIP): "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("managing director of PolyGram")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Patrick Savage: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Stone Roses’ accountant at")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("OJ")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Kilkenny")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Simon Crompton"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v(": acid house producer")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Brian Pugsley: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("engineer on")]), _vm._v(" Second Coming")]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Trevor Taylor: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("owner of Square One Studios")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Tom Zutaut: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A&R at Geffen Records")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Mark Tolle: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("producer on")]), _vm._v(" Second Coming "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("(Manor Park Studios)")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Al ‘Bongo’ Shaw: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("engineer on")]), _vm._v(" Second Coming "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("(Manor Park Studios)")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Simon Dawson"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v(": engineer/producer on")]), _vm._v(" Second Coming "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("(Rockfield Studios)")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Peter Leak: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("band manager")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Bill Price: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("producer/mixer on")]), _vm._v(" Second Coming")]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Terri Hall: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("press officer, The Stone Roses")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Doug Goldstein: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("manager of The Stone Roses,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("1994")]), _vm._v("–"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Bryn Bridenthal: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("head of")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("PR")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("at Geffen Records")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Sophie Muller: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("video-maker, ‘Ten Storey Love Song’")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Robbie Maddix: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("drummer, The Stone Roses,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("1995")]), _vm._v("–"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Susanne Filkins: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A&R at Geffen Records")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Nigel Ipinson-Fleming: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("keyboards, The Stone Roses,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("1995")]), _vm._v("–"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Noel Walters: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Ian Brown’s bodyguard")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Martell Prince: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Stone Roses’ bodyguard")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Aziz Ibrahim: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("guitarist, The Stone Roses,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("1996")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("John Nuttall: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Reni’s manager")])]), _vm._v(" "), _c('p', {
    staticClass: "x04-list-on-cast"
  }, [_vm._v("Simon Moran: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("promoter; manager of The Stone Roses,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("2011")]), _vm._v("–")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b0fc27c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cast.vue
// module id = 78
// module chunks = 0